/**
 * Frases do verso do Indique e Ganhe.
 * Espelha `legacy/fixe-api/helpers/mgmBackLink.js`.
 */
export const MGM_BACK_LABEL = 'Indique e ganhe';
export const MGM_BACK_PHRASE = 'Indique um amigo';

export interface MgmFabRef {
  kind?: string;
  url?: string;
}

/** URL pública do FAB MGM. Vazia quando o botão não existe. */
export function mgmFabUrl(fabs: MgmFabRef[] | undefined): string {
  const fab = fabs?.find((item) => item.kind === 'mgm' && item.url && /^https?:\/\//i.test(item.url));
  return fab?.url ?? '';
}
